module.exports = __webpack_public_path__ + "img/news-10.e37e91cf.png";